"use strict";

var toolbox_1 = require("node-sass-magic-importer/dist/toolbox");

module.exports = function globImporter() {
  return function importer(url, prev) {
    var nodeSassOptions = this.options;
    var includePaths = toolbox_1.buildIncludePaths(nodeSassOptions.includePaths, prev);
    var filePaths = toolbox_1.resolveGlobUrl(url, includePaths);

    if (filePaths) {
      var contents = filePaths.map(function (x) {
        return "@import '".concat(x, "';");
      }).join("\n");
      return {
        contents: contents
      };
    }

    return null;
  };
};